// ============================================================
//  Bragsheet React — firebase.js (Phase 0)
//  Firebase Auth init for the React SPA, using the Firebase v11
//  MODULAR SDK (tree-shakeable), NOT the compat SDK the vanilla
//  www/ tree loads via <script> tags.
//
//  This is a fresh, standalone copy of the config. It intentionally
//  does NOT import, require, or re-export anything from ../www/firebase.js
//  (forbidden by the Phase 0 brief). If the real config values change,
//  update BOTH files until the vanilla tree is retired at cutover.
// ============================================================

import { initializeApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
// NOTE: Firestore is intentionally NOT imported here. firebase.js is on the
// boot/first-render path (AuthContext imports `auth`), and firebase/firestore
// is by far the heaviest Firebase entry point. Keeping it out means startup and
// the login screen never download Firestore. The `db` handle now lives in the
// lazily-loaded ./firestore.js, pulled in on the first actual data call.

// Ported verbatim from www/firebase.js (brag-sheet-e994b project).
// authDomain is the verified custom domain that serves /__/auth/* for the
// OAuth handshake and email action links (see www/firebase.js for the why).
const firebaseConfig = {
  apiKey: 'AIzaSyAp5L1dzSAgftDJefG-P_nQqmzESwsAOUI',
  authDomain: 'auth.bragsheet.net',
  projectId: 'brag-sheet-e994b',
  storageBucket: 'brag-sheet-e994b.firebasestorage.app',
  messagingSenderId: '73088318693',
  appId: '1:73088318693:web:95b72d6b7f50a5fb8c280c',
  measurementId: 'G-CG745KHF5B',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Keep the browser session across reloads and offline starts (acceptance
// test 4: refresh must not log the user out). browserLocalPersistence is the
// web default, but we set it explicitly to match the vanilla app's intent and
// guard against any future default change.
setPersistence(auth, browserLocalPersistence).catch((err) => {
  console.warn('[Auth] Persistence setup failed:', err);
});
